import React, { ReactNode } from 'react';

interface FormSectionProps {
  title?: string;
  children: ReactNode;
  cardClassName?: string;
  className?: string;
}

export const FormSection: React.FC<FormSectionProps> = ({
  title,
  children,
  cardClassName,
  className,
}) => (
  <div className={`flex flex-col gap-5 w-full ${className ?? ''}`}>
    {title && (
      <h2 className="font-['Roboto'] text-[20px] font-bold leading-[1.4] text-[#004494]">
        {title}
      </h2>
    )}
    {/* 16 px of padding on a phone rather than 24 — the card is edge to edge there, so every pixel
        of it is taken out of the content's width. */}
    <div className={`bg-white rounded-[20px] md:rounded-[30px] ${cardClassName ?? 'p-4 md:p-6 flex flex-col gap-4 md:gap-5'}`}>
      {children}
    </div>
  </div>
);
